<div *ngIf="showQuiz" id="sip-quiz-wrapper" class="wrapper w-100">
  <app-payment-successfull [prizeAmount]="prizeAmount" [order]="order" (ontakeQuiz)="toggleQuiz($event)" *ngIf="!takeQuiz"></app-payment-successfull>
  <app-sip-quiz-question id="sip-quiz" [order]="order" [prizeAmount]="prizeAmount" *ngIf="takeQuiz"></app-sip-quiz-question>
  <div>
    <app-redeem-thank-you-page id="redeem-typ" [order]="order"></app-redeem-thank-you-page>
  </div>
</div>
